import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import PrescriptionView from "../../components/prescriptions/clinic-home";
import StickyLogo from "../../components/stickyLogo";

const PrescriptionsHome = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <PrescriptionView software="home" />
    </Main>
  </>
);

export default PrescriptionsHome;
